document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.getElementById('NavToggle');
  var nav = document.getElementById('SiteNav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
  }

  document.querySelectorAll('.js-copy-ip').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var text = btn.getAttribute('data-copy') || '';
      var hint = btn.querySelector('.vd-test-ip__hint');
      var original = hint ? hint.textContent : '';
      function done() {
        btn.classList.add('is-copied');
        if (hint) hint.textContent = 'Copied! Paste in F8';
        setTimeout(function () {
          btn.classList.remove('is-copied');
          if (hint) hint.textContent = original || 'Click to copy';
        }, 2200);
      }
      function fallback() {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.top = '-999px';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(ta);
        done();
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(fallback);
      } else {
        fallback();
      }
    });
  });

  document.querySelectorAll('.js-add-to-cart').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      if (!window.fetch) return;
      event.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var original = btn ? btn.textContent : '';
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Adding…';
      }
      fetch(form.action, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add failed');
          window.location.href = '/cart';
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (btn) {
            btn.disabled = false;
            btn.textContent = original;
          }
        });
    });
  });



  /* FAQ: keep one item open at a time inside [data-vd-faq] */
  document.querySelectorAll('[data-vd-faq]').forEach(function (wrap) {
    wrap.querySelectorAll('details').forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        wrap.querySelectorAll('details').forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  });

  document.querySelectorAll('[data-offer-end]').forEach(function (box) {
    var end = Date.parse(box.getAttribute('data-offer-end'));
    if (!end) return;
    var clock = box.querySelector('.vd-offer__clock');
    var ended = box.querySelector('.vd-offer__ended');
    var d = box.querySelector('[data-d]');
    var h = box.querySelector('[data-h]');
    var m = box.querySelector('[data-m]');
    var s = box.querySelector('[data-s]');
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick() {
      var left = end - Date.now();
      if (left <= 0) {
        box.classList.add('is-ended');
        if (clock) clock.hidden = true;
        if (ended) ended.hidden = false;
        if (box.classList.contains('vd-ticker-clock')) {
          if (box.getAttribute('data-hide-when-ended') === 'true') { box.hidden = true; box.style.display = 'none'; }
          else { box.textContent = '⏳ Offer ended'; }
        }
        return;
      }
      var days = Math.floor(left / 86400000);
      var hrs = Math.floor((left % 86400000) / 3600000);
      var mins = Math.floor((left % 3600000) / 60000);
      var secs = Math.floor((left % 60000) / 1000);
      if (d) d.textContent = pad(days);
      if (h) h.textContent = pad(hrs);
      if (m) m.textContent = pad(mins);
      if (s) s.textContent = pad(secs);
      requestAnimationFrame(function () { setTimeout(tick, 250); });
    }
    tick();
  });
});
